import { createPermission } from '@backstage/plugin-permission-common';

export const vendorPerformanceAccessPermission = createPermission({
  name: 'vendor-performance.access',
  attributes: {
    action: 'read',
  },
});

export const vendorPerformancePermissions = [vendorPerformanceAccessPermission];
